import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    marginTop: 60,
    flexDirection: "column",
  },
  secondContainer: {
    flexWrap: "wrap",
  },
  headerAndAdoptionContainer: {
    marginLeft: "10%",
    flexDirection: "column",
    maxWidth: "100%",
  },
  headerContainer: {
    marginRight: 50,
    maxWidth: "100%",
  },
  titleSugestao: {
    marginLeft: "10%",
    marginTop: 40,
    marginBottom: 20,
    fontSize: 16,
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  contentInvestorProfile: {
    padding: 10,
    width: 320,
    height: 38,
    alignSelf: "center",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    color: "#fff",
  },
  containerCardsHome: {
    marginBottom: 12,
  },
  containerForestInvestor: {
    flex: 1,
    alignItems: "center",
  },
  textInvestorProfile: {
    color: "#fff",
    textAlign: "center",
    textTransform: "uppercase",
  },
  TokenReleasesContainer: {
    marginTop: 12,
    marginBottom: 12,
    flex: 1,
    marginLeft: "10%",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
  },
});

export default styles;
